export default __webpack_public_path__ + "static/media/usa.d091fc0c.svg";